//check active header
$(function () {
    // var pageurl = window.location.href;
    // var lastChar = pageurl[pageurl.length - 1];
    // if(lastChar === '/'){
    //     pageurl = pageurl.slice('', -1);
    // }
    //
    // $(".nav-pills .nav-parent").each(function(){
    //     var href = $(this).find('.nav-treeview a').attr('href');
    //     if (href === pageurl)
    //     {
    //         $(this).addClass('menu-is-opening menu-open');
    //         $(this).find('.nav-treeview').css('display', 'block');
    //         $(this).find('.nav-treeview').addClass('nav-active');
    //         $(this).find('.link-parent').removeClass('active');
    //     }
    // });
});
